import AudioPlaybackButton from '@/components/modules/chat/AudioPlaybackButton'
import MarkdownRenderer from '@/components/shared/MarkdownRenderer'
import type { PlaybackState } from '@/hooks/useAudioPlayback'
import { cn } from '@/lib/utils'
import type { Message } from '@/types/chat'

interface ChatMessageProps {
  message: Message
  playbackState?: PlaybackState
  onToggleAudio?: () => void
}

export default function ChatMessage({ message, playbackState, onToggleAudio }: ChatMessageProps) {
  const isUser = message.role === 'user'
  const showAudioButton = !isUser && onToggleAudio && !message.id.startsWith('temp-')

  return (
    <div className={cn('flex w-full', isUser ? 'justify-end' : 'justify-start')}>
      <div
        className={cn(
          'max-w-[85%] rounded-2xl px-4 py-3 md:max-w-[75%]',
          isUser ? 'bg-primary text-primary-foreground' : 'bg-muted',
        )}
      >
        {isUser ? (
          <p className="whitespace-pre-wrap text-sm">{message.content}</p>
        ) : (
          <div className="text-sm">
            <MarkdownRenderer content={message.content} />
            {showAudioButton && (
              <div className="mt-2 flex justify-end">
                <AudioPlaybackButton state={playbackState ?? 'idle'} onToggle={onToggleAudio} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
